// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Comfirm/alert.css
// module id = 1928
// module chunks = 193